import React, { useEffect, useState } from "react";
import { api, formatDate } from "@/lib/api";
import { SubList } from "./_forms";

export default function Defenses({ staff }) {
  const staffName = (id) => staff.find((x) => x.id === id)?.full_name || id;
  const [warnings, setWarnings] = useState([]);
  useEffect(() => {
    api.get("/hr/warnings?limit=500").then(({ data }) => setWarnings(data.items || data || []))
      .catch(() => setWarnings([]));
  }, []);
  const warningLabel = (id) => {
    const w = warnings.find((x) => x.id === id);
    if (!w) return id;
    return `${(w.warning_type || w.type || "warning")} · ${formatDate(w.issue_date)}`;
  };
  return (
    <SubList
      endpoint="/hr/defenses" dataKey="items"
      lookups={{ staff_id: staffName, warning_id: warningLabel }}
      columns={[
        ["staff_id", "Employee", true], ["warning_id", "Warning Ref"],
        ["response_date", "Responded", "date"],
      ]}
      form={[
        { k: "staff_id", label: "Employee", type: "select",
          options: staff.map((s) => [s.id, `${s.full_name} (${s.employee_code || "—"})`]),
          required: true },
        { k: "warning_id", label: "Warning issued against me", type: "select", required: true,
          optionsFn: (vals) => {
            const filtered = vals.staff_id
              ? warnings.filter((w) => w.staff_id === vals.staff_id)
              : warnings;
            return filtered.length === 0
              ? [["", "— No warnings found for this employee —"]]
              : filtered.map((w) => [w.id,
                  `${(w.warning_type || w.type || "warning")} · ${formatDate(w.issue_date)} · ${(w.reason || "").slice(0, 50)}`]);
          },
        },
        { k: "response_date", label: "Response Date", type: "date", required: true },
        { k: "response", label: "Employee Response", textarea: true, required: true },
      ]}
      testId="defense"
      emptyText="No employee defense responses on file."
    />
  );
}
